/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./new-popup.vue?vue&type=template&id=65bdcc01&"
import script from "./new-popup.vue?vue&type=script&lang=js&"
export * from "./new-popup.vue?vue&type=script&lang=js&"
import style0 from "./new-popup.vue?vue&type=style&index=0&id=65bdcc01&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports